import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { APP_ROUTE_PREFIX } from '@app/enums';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { Location } from '@angular/common';

@Component({
  selector: 'app-pagenot-found',
  imports: [NzButtonModule],
  templateUrl: './pagenot-found.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './pagenot-found.component.scss',
})
export class PagenotFoundComponent {
  constructor(
    private router: Router,
    private location: Location
  ) {}

  handleNavigate() {
    this.router.navigate([APP_ROUTE_PREFIX]);
  }
  goBack(): void {
    this.location.back();
  }
}
